import { NgModule } from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HttpClientModule} from '@angular/common/http';
import { ModalModule} from 'ngx-bootstrap';
import {TabsModule} from 'ngx-bootstrap/tabs';
import { ReactiveFormsModule} from '@angular/forms';
import {DataTablesModule} from 'angular-datatables';
import {SharedModule} from '../../_shared/shared.module';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import {AutoSeedingComponent } from './auto-seeding.component';
import { Daterangepicker } from 'ng2-daterangepicker';
const routes: Routes = [
  {
    path: '',
    component: AutoSeedingComponent,
    data: {
      title: 'Quản lý Auto Seeding'
    },
  }

];
@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild(routes),
    TabsModule,
    DataTablesModule,
    HttpClientModule,
    ModalModule.forRoot(),
    Daterangepicker,
    ReactiveFormsModule,
    AngularMultiSelectModule
  ],
  declarations: [AutoSeedingComponent]
})
export class AutoSeedingModule { }



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/auto-seeding/auto-seeding.module.ts